"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function isDOM(obj) {
  // DOM, Level2
  if ('HTMLElement' in window) {
    return obj && obj instanceof HTMLElement;
  } // Older browsers


  return !!(obj && 'object' === typeof obj && 1 === obj.nodeType && obj.nodeName);
}

var _default = isDOM;
exports.default = _default;